import React from "react";

const TabSalesAnalitics: React.FC = () => {
  return (
    <div>
      <h2>Price stats</h2>
      <h2>Period comparison</h2>
      <h2>Price and withdrawals</h2>
    </div>
  );
};

export default TabSalesAnalitics;
